import { useSelector, useDispatch } from 'react-redux';
import FJAnimateImageModal from './FJAnimateImageModal';
import FJActionModal from '../../../redux/action/FJActionModal';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage';
const FJAnimateImageModalContainer = () => {
    const dispatch = useDispatch();
    useLocalStore();

    const animateImageModalDisplay = useSelector(state => state.modals.animateImageModalDisplay);
    const onTryNow = () => {
        dispatch(FJActionImageToImage.animateImageAction());
        dispatch(FJActionModal.hideAnimateImageModalAction());
    };
    const onClose = () => {
        dispatch(FJActionModal.hideAnimateImageModalAction());
    };
    return <FJAnimateImageModal active={animateImageModalDisplay} onTryNow={onTryNow} onClose={onClose} />;
};

export default FJAnimateImageModalContainer;
